/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */

import { css, jsx } from '@compiled/react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { SmartCardProvider } from '@atlaskit/link-provider';
import { Stack, Text } from '@atlaskit/primitives/compiled';

import { LinkListCompact } from './link-list-compact';
import { LinkListFull } from './link-list-full';

const messages = defineMessages({
	link_list_header: {
		id: 'smart_knowledge_card.link_list_header',
		defaultMessage: 'Recent updates',
		description: 'Text for the link list header',
	},
});

interface LinkListProps {
	headerVisible?: boolean;
	urls: string[];
}

const containerRoot = css({
	width: '100%',
	containerType: 'inline-size',
	containerName: 'link-list-knowledge-card-container',
});

const showCompact = css({
	display: 'block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
	'@container link-list-knowledge-card-container (min-width: 481px)': {
		display: 'none',
	},
});

const showFull = css({
	display: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
	'@container link-list-knowledge-card-container (min-width: 481px)': {
		display: 'block',
	},
});

export const DEFAULT_MAX_SOURCES = 4;

export const LinkList = ({ urls, headerVisible }: LinkListProps): JSX.Element => {
	return (
		<Stack space="space.050">
			{headerVisible && (
				<Text color="color.text" size="medium" weight="semibold">
					<FormattedMessage {...messages.link_list_header} />
				</Text>
			)}
			<div css={containerRoot}>
				<SmartCardProvider>
					<div css={showCompact}>
						<LinkListCompact urls={urls} />
					</div>
					<div css={showFull}>
						<LinkListFull urls={urls} />
					</div>
				</SmartCardProvider>
			</div>
		</Stack>
	);
};
